'use server';

import { getOAuthFullName, getSessionUser } from '@/lib/auth/session';
import { isAdminUser } from '@/services/auth.service';

export interface SessionSummary {
  email: string;
  fullName: string | null;
  isAdmin: boolean;
}

export async function getSessionSummaryAction(): Promise<SessionSummary | null> {
  const user = await getSessionUser();
  if (!user) {
    return null;
  }

  return {
    email: user.email ?? '',
    fullName: getOAuthFullName(user),
    isAdmin: await isAdminUser(user.id),
  };
}
